import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookiePolicyComponent, CookiePolicyService } from './index';



@NgModule({
  declarations: [
    CookiePolicyComponent
  ],
  providers: [
    CookiePolicyService,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CookiePolicyComponent,
  ]
})
export class CookiePolicyModule { }
